import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import {
    CLASSROOMS_CATALOG_CONFIG,
    CLASSROOMS_CATALOG_TYPE,
    ClassroomsSelectedItems,
} from './InstancesCatalogClassrooms-types'

const InstancesCatalogClassroomsComponent = () => {
    const [selectedItems, setSelectedItems] = useState<ClassroomsSelectedItems>([])

    return (
        <Content title={CLASSROOMS_CATALOG_TYPE}>
            <Catalog
                type={CLASSROOMS_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                additionalData={{}}
                fixedHeader={CLASSROOMS_CATALOG_CONFIG.fixedHeader}
                isExistRightToolbar={CLASSROOMS_CATALOG_CONFIG.isExistRightToolbar}
                treeView={CLASSROOMS_CATALOG_CONFIG.treeView}
            />
        </Content>
    )
}

export const InstancesCatalogClassrooms = checkAvailableModule('instancesCatalog/classrooms')
    ? InstancesCatalogClassroomsComponent
    : null
